import React, { Router, Route, Redirect, Switch } from 'react-router-dom';
import { history } from '../utils/history';
import Intro from './pages/Intro';
import BorrowStep from './pages/BorrowStep';
import CheckIn from './pages/CheckIn';
import Welcome from './pages/Welcome';

const App = () => (
  <div className="font-roboto bg-white">
    <Router history={history}>
      <Switch>
        <Route path="/intro" component={Intro} />
        <Route path="/main" component={BorrowStep} />
        <Route path="/checkin" component={CheckIn} />
        <Route path="/dtc-mailer/continue" component={Welcome} />
        <Redirect to="/intro" />
      </Switch>
    </Router>
  </div>
);

export default App;
